module.exports = __webpack_public_path__ + "static/media/aboutUs.4d439644.svg";